function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.51 11.17a19.59 19.59 0 0 0-2.62-2.86 10.74 10.74 0 0 0-7-3.12c-5.43 0-9.37 6.16-9.54 6.42a.81.81 0 0 0 0 .83c.17.26 4.14 6.42 9.54 6.42 2.35 0 4.79-1.16 7.05-3.35a19.16 19.16 0 0 0 2.53-3 1.13 1.13 0 0 0 .04-1.34zm-9.58 6.11C8.14 17.28 5 13.41 4 12c1-1.41 4.14-5.28 7.94-5.28 3.8 0 7.06 3.73 8.13 5.1-1.07 1.47-4.19 5.46-8.14 5.46z M11.91 8.48a3.4 3.4 0 1 0 2.51 5.69l.13-.15a.71.71 0 0 0 .26-.55.73.73 0 0 0-.73-.73.7.7 0 0 0-.45.17l-.25.26a2 2 0 1 1-1.46-3.25 1.89 1.89 0 0 1 1.94 1.43v.15a.68.68 0 0 0 .41.43.71.71 0 0 0 1-.66.77.77 0 0 0 0-.2 3.52 3.52 0 0 0-3.36-2.59z"
});

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e7776421.svg";
export { ForwardRef as ReactComponent };